module.exports = __webpack_public_path__ + "static/image05a@2x-cc08a6e2fa8c808bc6ec60526150c8ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/monzo/image05a@2x.jpg
// module id = 410
// module chunks = 3627797113349 20562973939449 33019919093843